import { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    borderColor: '#E0E0E0',
    borderStyle: 'solid',
    borderWidth: '0px 0px 1px 0px',
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'white',
    borderColor: '#E0E0E0',
    borderStyle: 'solid',
    borderWidth: '1px 0px 1px 0px',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#FAFAFA',
    display: 'flex',
    flexDirection: 'column',
    ...theme.homeStyle.bodyText,
    color: '#828282',
    '& img': {
      width: '100%',
      maxWidth: '100%',
      margin: '16px 0px',
    },
    '& th': {
      border: '1px solid grey',
      padding: 8,
    },
    '& td': {
      border: '1px solid grey',
      padding: 8,
    },
    '& table': {
      borderSpacing: 0,
      border: '1px solid grey',
    },
    '& ol': {
      paddingLeft: 20,
    }
  },
}))(MuiAccordionDetails)

// data = [{title,desc},...]
const TextCollapseSp = ({ data, searchedTitle }) => {
  const [openState, setOpenState] = useState(new Array(data.length).fill(false))

  const toggleExpand = (index, specialAction = null) => {
    let newState = [...openState]
    newState[index] = (specialAction === 'openOnly') ? true : !newState[index]
    setOpenState(newState)
  }

  useEffect(() => {
    if (!!searchedTitle && Array.isArray(data)) {
      const indexOfTheTitle = data.findIndex(obj => obj.title === searchedTitle)
      if (indexOfTheTitle !== -1) toggleExpand(indexOfTheTitle, 'openOnly')
    }
  },[searchedTitle,data])

  return (
    <div>
      {data.map(({ title, desc, subtitle='', icon }, index) => (
        <Accordion
          square
          expanded={openState[index]}
          key={title}
        >
          <AccordionSummary onClick={() => toggleExpand(index)}>
            <a id={title} />
            { icon && (
              <img src={icon} alt="" style={{ height: 40, weight: 40, marginRight: 5 }} />
            ) }
            {title}
            <div style={{ flexGrow: 1 }} />
            <span style={{color:'#828282',marginRight:16}}>{subtitle}</span>
            {openState[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </AccordionSummary>
          <AccordionDetails>{desc}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}

export default TextCollapseSp
